import { Text } from "@chakra-ui/react";
import React from "react";

function TextError({val}){
    return(
        <Text color={'red'}>{val}</Text>
    )
}

export default TextError;